export interface PricingPlan {
  title: string
  monthlyPrice: number | null
  annualPrice: number
  period?: string
  description: string
  features: string[]
  cta: string
  popular: boolean
}

export function getPricingData(isAnnual: boolean): PricingPlan[] {
  return [
    {
      title: 'Free',
      monthlyPrice: 0,
      annualPrice: 0,
      description: 'Perfect for exploring and learning',
      features: [
        '  Limited usage credits',
        '  Limited nodes available',
        '+ Community support',
        '- No deployment support'
      ],
      cta: 'Get Started',
      popular: false
    },
    {
      title: 'Pro',
      monthlyPrice: 34,
      annualPrice: 29,
      description: 'For individual developers and creators',
      features: [
        isAnnual ? 'G $60 of included usage credits' : 'G $5 monthly usage credits',
        '+ Access to thousands of nodes',
        '+ Unlimited workflows',
        '+ Deploy your workflows',
        '+ GPU access',
        '+ Dedicated support'
      ],
      cta: 'Upgrade to Pro',
      popular: true
    },
    {
      title: 'Teams',
      monthlyPrice: 119,
      annualPrice: 99,
      description: 'For small teams up to 4 users',
      features: [
        isAnnual ? 'G $120 of included usage credits' : 'G $10 monthly usage credits',
        '+ Everything in Pro', 
        '+ Real-time collaboration 🎨', 
        '+ Team workspace', 
        '+ Basic analytics', 
        '+ Dedicated support'
      ],
      cta: 'Start with Teams',
      popular: false
    },
    {
      title: 'Teams+',
      monthlyPrice: null,
      annualPrice: 499,
      period: '/month',
      description: 'For teams up to 24 users',
      features: [
        'G $200 of included usage credits',
        '+ Everything in Teams', 
        '+ Up to 24 team members', 
        '+ Advanced analytics', 
        '+ Resource priority', 
        '+ Priority support'
      ],
      cta: 'Start with Teams+',
      popular: false
    }
  ]
}

export const PRICING_FEATURE_ICONS = {
  'G': { type: 'gift', className: 'h-5 w-5 text-green-500 mr-2 shrink-0' },
  '-': { type: 'x', className: 'h-5 w-5 text-orange-500 mr-2 shrink-0' },
  '+': { type: 'check', className: 'h-5 w-5 text-green-500 mr-2 shrink-0' }
} as const